/* Brands A to Z: after a letter jump, focus lands on the group heading.
   The browser does the scrolling (the heading's scroll offset clears the sticky header and
   the letter bar), so focus is moved without scrolling again. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-brands-bar]');
  if (!bar) return;

  function focusGroup(hash) {
    if (!hash || hash.indexOf('#brands-') !== 0) return;
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (e) {
      return;
    }
    var target = document.getElementById(id);
    if (target) target.focus({ preventScroll: true });
  }

  bar.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#brands-"]');
    if (!link) return;
    window.requestAnimationFrame(function () {
      focusGroup(link.getAttribute('href'));
    });
  });

  window.addEventListener('hashchange', function () {
    focusGroup(window.location.hash);
  });

  // Arriving from another page with a letter hash (/pages/brands#brands-m).
  focusGroup(window.location.hash);
})();
